import {Injectable} from "@angular/core";
import {Doctor} from "../doctor";
import {DoctorsService} from "./doctors.service";
import {Observable, shareReplay} from "rxjs";

@Injectable()
export class DoctorSelectorService {
  readonly doctors: Observable<Doctor[]>;

  constructor(doctorsService: DoctorsService) {
    this.doctors = doctorsService.getAllDoctors().pipe(shareReplay(1));
  }
}
